import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const trunkDisplacement: typeof valueTypeRenderers.trunkDisplacement = {
  label: () => unitConverter.trunkDisplacement().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.trunkDisplacement().title(),
      render: (n) => unitConverter.trunkDisplacement(n).valueAsString(),
    }),
}
